// Weight and distance units. Sets keep the unit they were entered in; display converts to the person's units.
import type { Units } from './auth.ts';

const LB_PER_KG = 2.204_622_621_8;

export function convertWeight(weight: number, from: Units, to: Units): number {
  if (from === to) return weight;
  return from === 'kg' ? weight * LB_PER_KG : weight / LB_PER_KG;
}

/** Rounds to the nearest plate-friendly step (lb: 0.5, kg: 0.25), dropping float noise. */
export const roundWeight = (w: number, unit: Units) => {
  const step = unit === 'lb' ? 0.5 : 0.25;
  return Math.round(w / step) * step;
};

/** How far one tap of + or − moves the weight. */
export const weightStep = (unit: Units) => (unit === 'lb' ? 5 : 2.5);

/** Cardio distance shown in miles for lb people and kilometres for kg people. */
export const distanceUnit = (unit: Units) => (unit === 'lb' ? 'mi' : 'km');
export const metresPer = (unit: Units) => (unit === 'lb' ? 1609.344 : 1000);

